import React from "react";

const Home = () => {
  return (
    <div className="flex h-[500px] w-full items-center justify-center">
      <div className="text-4xl font-semibold text-normaldark text-center ">
        <p className="underline decoration-double">Dashboard Coming Soon ...</p>
      </div>
    </div>
  );
};

export default Home;
